module.exports = "/assets/src/client/assets/logo-typographic.svg";